import { render, staticRenderFns } from "./CreateDebtorDialog.vue?vue&type=template&id=f52b0ef8&"
import script from "./CreateDebtorDialog.vue?vue&type=script&lang=js&"
export * from "./CreateDebtorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports